// extracted by mini-css-extract-plugin
module.exports = {"sorter":"NotesSorter_sorter__WWWlL","sortTrigger":"NotesSorter_sortTrigger__FH_V7","itemIcon":"NotesSorter_itemIcon__R_TMP"};